import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { getCountryFromUrl } from '~/core/i18n/functions';
import { MT_APP_URL } from '~/core/i18n/constants';
import { COUNTRY_CODE } from '~/core/i18n/constants/countryCode';
import useLocaleStore from '~/stores/useLocaleStore';
var abortWithNotFound = function abortWithNotFound(reason) {
  return abortNavigation({
    message: "abortWithNotFound: ".concat(reason),
    statusCode: 404
  });
};
export default defineNuxtRouteMiddleware(function () {
  var _useRequestURL = useRequestURL(),
    hostname = _useRequestURL.hostname;
  var country = getCountryFromUrl({
    hostname: hostname
  });
  if (!country) {
    return;
  }
  var locale = useLocaleStore();
  locale.currentDomainCountry = country;
  var ruHostName = new URL(MT_APP_URL[COUNTRY_CODE.RU]).hostname;
  if (locale.isCis && hostname === ruHostName) {
    return abortWithNotFound('locale isCis, origin is Ru');
  }
  if (locale.isRu && hostname !== ruHostName) {
    return abortWithNotFound('locale isRu, origin is CIS');
  }
});